export default {"src":"/_next/static/media/dock.119943d0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};